module.exports = __webpack_public_path__ + "static/media/logo-bpifrance.5582d7cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-bpifrance.jpg
// module id = 435
// module chunks = 0